import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { PageComponent } from "@components/page/page.component";
import { Produkt } from "~app/common/models/produkt/ProduktSearchResponseDTO";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";
import { FormModeName, TabName } from "../produkt-detail/produkt-details.models";
import { ProduktSearchPanelComponent } from "./produkt-search-panel/produkt-search-panel.component";
import { ProduktSearchResultComponent } from "./produkt-search-result/produkt-search-result.component";
import { ProduktSearchTexts } from "./produkt-search.texts";

@Component({
    selector: "rask-produkt-search",
    templateUrl: "./produkt-search.component.html",
    styleUrls: ["./produkt-search.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        ProduktSearchPanelComponent,
        ProduktSearchResultComponent
    ]
})
export class ProduktSearchComponent {
    results: Produkt[];
    texts = ProduktSearchTexts.texts;

    private readonly authenticationService = inject(AuthenticationService);
    private readonly router = inject(Router);

    readonly canCreate = () => this.authenticationService.canEdit();

    create = (): void => {
        this.router.navigate([
            "/produkt",
            FormModeName.New,
            TabName.basdata
        ]);
    };

    onResult(searchResult: Produkt[]) {
        this.results = searchResult;
    }
}
